import type { NavigateOptions } from 'react-router-dom';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const usePartitionsPageRedirect = (codeFromParams?: string) => {
  const { code } = useModuleByCodeParam();

  const { doRedirectWithSavePageUrl, doRedirectOnPrevPage, ...methods } = usePagesRedirect(
    'usePartitionsPageRedirect'
  );

  return {
    ...methods,
    goBack: (navState?: NavigateOptions) => doRedirectOnPrevPage('/', navState),
    goToPartitionsPage: (navState?: NavigateOptions) =>
      doRedirectWithSavePageUrl(`/common/${codeFromParams ?? code}/partitions`, navState),
  };
};
